import React from 'react';
import PropTypes from 'prop-types';
import '../_styles_/DownloadSampleFile.css';
import Constants from '../utils/Constants';
import DownloadButton from './buttons/DownloadButton';

DownloadSampleFile.propTypes = {
    text: PropTypes.string.isRequired,
    sampleType: PropTypes.string.isRequired,
    fileTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
    fileName: PropTypes.string,
};

DownloadSampleFile.defaultProps = {
    fileName: null,
};

function DownloadSampleFile(props) {
    const {
        text,
        sampleType,
        fileTypes,
        fileName,
    } = props;
    const errorMessageKeys = {
        unauthorized: 'sample-files-download.download-failed-unauthorized',
        failed: 'sample-files-download.download-failed',
    };
    return (
        <div className="download-sample-file">
            {text}
            {fileTypes.map((fileType) => (
                <DownloadButton
                    urlPath={Constants.DOWNLOAD_SAMPLE_FILE}
                    data={{
                        sampleType,
                        fileType,
                    }}
                    label={fileName && `${fileName}.${fileType.toLowerCase()}`}
                    errorMessageKeys={errorMessageKeys}
                    className={`download-sample-file-button--${fileType}`}
                    key={fileType}
                />
            ))}
        </div>
    );
}

export default DownloadSampleFile;
